import React from "react";

import Icon1 from "../Assets/img/why-choose/choose-1.svg";
import Icon2 from "../Assets/img/why-choose/choose-2.svg";
import Icon3 from "../Assets/img/why-choose/choose-3.svg";
import Icon4 from "../Assets/img/why-choose/choose-4.svg";
import Icon5 from "../Assets/img/why-choose/choose-5.svg";
import Icon6 from "../Assets/img/why-choose/choose-6.svg";
import Icon7 from "../Assets/img/why-choose/choose-7.svg";
import Icon8 from "../Assets/img/why-choose/choose-8.svg";

const WhyChooseMain = [
  {
    id: "item1",
    icon: Icon1,
    title: "Unique & Best Quality",
    text: "Softifybd Limited (Service Provider) assures you the best quality solution with the years of experience in ISP industry.",
  },
  {
    id: "item2",
    icon: Icon2,
    title: "Fast & Responsive",
    text: "Time is more valuable than everything. Our software is so faster and more responsive and helps the client to save their times. You can access our ISP Management Software from anywhere anytime.",
  },
  {
    id: "item3",
    icon: Icon3,
    title: "User Flexibility",
    text: "We made software for every kind of user even who have no knowledge of any uses of software. Our User Interface of the ISP Management System is more flexible than any other ISP management software.",
  },
  {
    id: "item4",
    icon: Icon4,
    title: "Easy Maintenance",
    text: "Launch and Support Main particularity of our software is tension-free maintenance. Our software has different user role and module permission system which helps you to implement the division of responsibility.",
  },
  {
    id: "item5",
    icon: Icon5,
    title: "Safe & Secured Data",
    text: "We Softifybd are much more careful on about your data. Data Safety and Security is our prime responsibility. For your highest data safety and security, you can rely on us.",
  },
  {
    id: "item6",
    icon: Icon6,
    title: "100% Uptime Guarantee",
    text: "Softifybd guarantee you 100% Uptime. With our software, we provide you best Database Server with SSL Certificate and Maximum compatibility.",
  },
  {
    id: "item7",
    icon: Icon7,
    title: "Life Time Support",
    text: "Softifybd Limited have 24/7 Help & Support Center. To ensure the client satisfaction our dedicated support team is always ready to make you smile and happy.",
  },
  {
    id: "item8",
    icon: Icon8,
    title: "Cheap & Cost Effective",
    text: "In the competitive market, we offer you the best software within the best price. Our software helps you to decrease cost and increase efficiency in your business.",
  },
];

const WhyChoose = () => {
  return (
    <>
      <section className="why-choose-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-12">
              <div className="section-title">
                <h3>Why Choose ISP Digital</h3>
                <p>
                  Why ISP Digital would be a better choice in the ISP industry?
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {WhyChooseMain.map((SingleCard) => (
              <div className="col-lg-4 col-md-4 col-12" key={SingleCard.id}>
                <div className="single-choose">
                  <div className="choose-image">
                    <img src={SingleCard.icon} alt="#" />
                  </div>
                  <div className="choose-content">
                    <h4 className="choose-title">{SingleCard.title}</h4>
                    <p>{SingleCard.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default WhyChoose;
